import { useQueryHelper } from '@anytag/shared-hooks';
import { PostDetailsType } from '@anytag/shared-types';
import { useInstagramInteractionTaggedPostDetailsQuery } from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export type TemplatePostDetailsType = Pick<PostDetailsType, 'id' | 'mainSocialAccountId'>;

export interface TemplateProps {
  className?: string;
}

export const Template = ({ className }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPost } = usePostModalContext<TemplatePostDetailsType>();
  const { data, loading } = useInstagramInteractionTaggedPostDetailsQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId,
    variables: { postId: Number(selectedPost?.id), accountId: Number(selectedPost?.mainSocialAccountId) },
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      closeModal?.();
    }
  });

  const details = data?.instagramInteractionTaggedPostDetails;

  return (
    <PostModal.DetailsTemplate
      loading={loading}
      className={className}
      data={
        details
          ? {
              socialMedia: 'INSTAGRAM',
              postUrl: details?.postUrl,
              caption: details?.content,
              postDate: details?.postDate,
              comments: details.commentList || [],
              images: details?.postImageUrl ? [details.postImageUrl] : [],
              statistics: { likes: details?.likes, comments: details?.comments },
              info: {
                followers: null,
                avatar: details?.avatarUrl,
                name: details?.instagramAccountName
              }
            }
          : undefined
      }
    />
  );
};
